<template>
  <div>
    <div class="is-flex justify-content-center is-fullHeight">
      <div class="content justify-content-center">
        <div class="has-text-left" v-if="!isSubmit">
          <h3>Lost Password</h3>
          <p>Follow these steps to reset your account.</p>
          <ol class="pl-4">
            <li v-for="rule in this.rules" :key="rule.id">{{rule.message}}</li>
          </ol>
          <div class="login-container-p4-round-white">
            <form>
              <div class="field">
                <div class="field-body">
                  <div class="field has-text-left">
                    <div class="control">
                      <label for="formLostPasswordEmail">Enter Email Address</label>
                      <input
                        id="formLostPasswordEmail"
                        class="input"
                        type="email"
                        v-model="email"
                        :class="{ 'is-danger': this.hasError }"
                        required
                        autofocus
                      />
                    </div>
                    <span v-if="this.emailMsg" class="help is-danger">{{ emailMsg }}</span>
                  </div>
                </div>
              </div>
              <div class="field">
                <button
                  class="button is-primary is-fullwidth"
                  type="submit"
                  @click.stop.prevent="submitForm"
                >Send Reset Link</button>
              </div>
            </form>
            <router-link to="/login" class="btn-link">&lt; Back to Log In</router-link>
          </div>
        </div>
        <!--confirm message-->
        <div class="has-text-center" v-if="isSubmit">
          <div class="padding-top">
            <font-awesome-icon :icon="['fal', 'paper-plane']" size="2x"/>
          </div>
          <h3>Password Reset Email Sent</h3>
          <p>
            {{ this.message }}
            <br/>check your email and click on the password reset link.
          </p>
          <router-link to="/login" class="btn-link">&lt; Back to Log In</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPaperPlane,
} from '@fortawesome/pro-light-svg-icons';
import EmailUtils from '@/mixins/EmailUtils';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faPaperPlane,
);


export default {
  mixins: [EmailUtils, NotificationManager],
  data() {
    return {
      email: null,
      isSubmit: false,
      hasError: false,
      rules: [
        { message: 'Enter your email address' },
        { message: 'Check your email and click on the password reset link' },
        { message: 'Follow the instructions and reset your password' },
      ],
      messages: [],
      emailMsg: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
    };
  },
  methods: {
    ...mapActions(['lostPassword']),
    async submitForm() {
      let errors = 0;
      this.resetErrors();
      if (!this.email) {
        errors += 1;
        this.emailMsg = 'Email address is required.';
        this.hasError = true;
      } else if (!this.isWelformed(this.email)) {
        errors += 1;
        this.emailMsg = 'Email address is invalid.';
        this.hasError = true;
      }
      if (errors > 0) {
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      } else {
        try {
          const maskedEmail = this.mask(this.email);
          this.message = `An Email has been sent to ${maskedEmail}`;
          await this.lostPassword({ email: this.email });
          this.isSubmit = true;
        } catch (error) {
          this.hasError = true;
          if (error.response.status === 400) {
            this.message = `There were some errors. ${error.response.data.message}`;
          }
          if (error.response.status === 500) {
            this.message = 'Network Error';
          }
          this.messages.push(this.message);
          this.showNotification('danger', this.messages);
          this.isSubmit = false;
        }
      }
    },
    resetErrors() {
      this.hasError = false;
      this.messages = [];
      this.emailMsg = '';
    },
  },
};
</script>

<style lang="sass" scoped>
  .login-container-p4-round-white
    border-radius: 4.8px
    padding: 1.5rem !important
    background-color: white
    width: 300px

  .justify-content-center
      -webkit-box-pack: center !important
      -ms-flex-pack: center !important
      justify-content: center !important
  .padding-top
    padding-top: 1rem
</style>
